module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"OpeningHours":{"statusClosed":"Nyní máme zavřeno","statusOpen":"Nyní máme otevřeno","closed":"zavřeno"}},"de":{"OpeningHours":{"statusClosed":"Wir sind jetzt geschlossen.","statusOpen":"Wir sind jetzt offen"}},"sk":{"OpeningHours":{"statusClosed":"Teraz máme zatvorené","statusOpen":"Teraz máme otvorené"}}}')
  delete Component.options._Ctor
}
